import { render, staticRenderFns } from "./TranscriptionInterfaceLocal.vue?vue&type=template&id=502db46a&"
import script from "./TranscriptionInterfaceLocal.vue?vue&type=script&lang=js&"
export * from "./TranscriptionInterfaceLocal.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionInterfaceLocal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports